<template>
  <div class="list" :class="{ 'list--hidden': !showList }">
    <div class="list__filter">
      <div class="list__results">
        <p>
          <span>{{ searchResults.length }}</span> entreprise{{
            searchResults.length > 1 ? "s" : ""
          }}
          trouvée{{ searchResults.length > 1 ? "s" : "" }}
        </p>
      </div>
      <the-searchbar v-model="search" />
      <the-multiselect />
    </div>

    <div class="list__content">
      <div class="list__items">
        <div
          class="list__item"
          v-for="entreprise in searchResults"
          :key="entreprise.siret"
        >
          <card :entreprise="entreprise" />
        </div>
      </div>
    </div>

    <button class="list__toggle" @click="toggleList"></button>
  </div>
</template>

<script>
import Card from "@/components/Card.vue";
import TheSearchbar from "@/components/TheSearchbar.vue";
import TheMultiselect from "@/components/TheMultiselect.vue";

export default {
  components: {
    Card,
    TheSearchbar,
    TheMultiselect,
  },
  data() {
    return {
      slug: this.$route.params.slug,
      page: null,
      search: "",
      loading: false,
      showList: this.$store.state.showList,
      // showList: true,
    };
  },
  methods: {
    toggleList() {
      this.$store.commit("toggleList");
      this.showList = this.$store.state.showList;
      // this.showList = !this.showList;
    },
  },
  computed: {
    entreprises() {
      return this.$store.getters.entreprises;
    },
    searchResults() {
      if (!this.loading) {
        if (this.search != "") {
          return this.entreprises.filter((entreprise) => {
            return entreprise.title
              .toLowerCase()
              .includes(this.search.toLowerCase());
          });
        } else {
          return this.entreprises;
        }
      } else {
        return [];
      }
    },
  },
  mounted() {
    this.$store.dispatch("filterEntreprisesByMarker", this.slug);
    // console.log(this.slug);
    // if (!this.showList) {
    //   setTimeout(() => {
    //     this.toggleList();
    //   }, 100);
    // }
  },
};
</script>

<style lang="scss" scoped>
.list {
  position: relative;
  height: calc(100% - 90px);
  width: 100%;
  display: flex;
  flex-direction: column;
  pointer-events: all;
  transform: translate3d(0, 0, 0);
  transition: transform 0.6s var(--ExpoEaseOut);
  will-change: transform;
  //tablet
  @media (min-width: 768px) {
    height: 100%;
  }
  &--hidden {
    transform: translate3d(0, 100%, 0);
    //tablet
    @media (min-width: 768px) {
      transform: translate3d(-100%, 0, 0);
    }
    .list__toggle {
      bottom: calc(200% + 20px);
      @media (min-width: 768px) {
        bottom: unset;
      }
      &::after {
        background-image: url("../assets/images/menu.svg");
        filter: invert(1);
        transform: rotate(0deg);
      }
    }
  }
  &__toggle {
    z-index: 1000;
    position: absolute;
    top: unset;
    bottom: calc(100% + 20px);
    left: unset;
    right: 20px;
    width: 50px;
    height: 50px;
    background-color: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    border-radius: 50%;
    border: none;
    outline: none;
    cursor: pointer;
    transition: background-color 0.3s, transform 0.3s;
    //tablet
    @media (min-width: 768px) {
      position: absolute;
      top: 20px;
      left: calc(100% + 20px);
      right: unset;
      width: 50px;
      height: 50px;
    }
    &:active {
      transform: scale(0.96);
    }
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      // background-image: url("../assets/images/icons/icon-chevron.svg");
      background-size: 30% auto;
      background-repeat: no-repeat;
      background-position: center;
      // filter: invert(1);
      // transform: rotate(-90deg);
      background-image: url("../assets/images/icons/icon-close.svg");
      // filter: invert(1);
      transform: rotate(0deg);
    }
    &:hover {
      background-color: rgba(255, 255, 255, 1);
    }
  }
  &__filter {
    z-index: 100;
    width: auto;
    height: auto;
    margin: 0;
    padding: 25px;
    background-color: var(--white);
  }
  &__results {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 20px;
    margin: 0;
    margin-bottom: 10px;
    border-radius: 5px;
    background-color: var(--green);
    // user-select: none;
    // cursor: pointer;
    // &:hover {
    //   background-color: #008f3e;
    // }
    &--active {
      border-radius: 5px 5px 0 0;
      img {
        transform: rotate(0deg) !important;
      }
    }
    p {
      flex: 1 1 0;
      color: var(--white);
      font-size: 14px;
      // font-weight: 600;
      span {
        font-weight: 600;
      }
    }
    img {
      flex: 0 0 auto;
      width: 15px;
      height: 15px;
      transform: rotate(180deg);
    }
  }
  &__content {
    flex: 1 1 0;
    background-color: var(--white);
    border-top: solid 1px var(--lightGray);
    overflow: hidden;
  }
  &__items {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
  }
  &__item {
    overflow: hidden;
    border-bottom: 1px solid var(--lightGray);
  }
}
</style>
